export default __webpack_public_path__ + "static/media/HV B2B Banner vinyl.9c038a0c.jpg";